import client from '../client.js';
import getQuery from './get.graphql';
import getAllQuery from './getAll.graphql';

export const getProducts = async function (input) {
    const inputs = Object.assign({ count: 50 }, input);
    let results = await client.request(getAllQuery, inputs);
    return results.products;
};

export const getProduct = async function (input) {
    let results = await client.request(getQuery, input);
    return results.product;
};
